var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00E2A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_196341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 10.4749C18.2856 10.4749 16.8905 11.8699 16.8905 13.5848V20.1551C16.8905 21.8699 18.2855 23.2655 20.0004 23.2655C21.7153 23.2655 23.1108 21.87 23.1108 20.1551V13.5848C23.1108 11.87 21.7153 10.4749 20.0004 10.4749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4408 20.055V17.0447C26.4408 16.6306 26.1049 16.2947 25.6908 16.2947C25.2767 16.2947 24.9408 16.6306 24.9408 17.0447V20.055C24.9408 22.6629 22.725 24.785 20.0004 24.785C17.2758 24.785 15.0605 22.6629 15.0605 20.055V17.0447C15.0605 16.6306 14.7246 16.2947 14.3105 16.2947C13.8964 16.2947 13.5605 16.6306 13.5605 17.0447V20.055C13.5605 23.2443 16.0522 25.8779 19.2504 26.239V28.2244H15.8305C15.4716 28.2244 15.1806 28.5154 15.1806 28.8748C15.1806 29.2342 15.4716 29.5252 15.8305 29.5252H24.1703C24.5297 29.5252 24.8207 29.2342 24.8207 28.8748C24.8207 28.5154 24.5297 28.2244 24.1703 28.2244H20.7504V26.239C23.9487 25.8779 26.4408 23.2442 26.4408 20.055Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_196341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioa);
export default __webpack_public_path__ + "static/media/audioa.74a9f6550de527c5175cd22e3acedee2.svg";
export { ForwardRef as ReactComponent };